import { h } from 'preact'

const PATH_D =
    'M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z'

const STROKE = '#C4A46F'
const GOLD = '#C4A46F'
const WHITE = '#FFFFFF'

const VARIANT_STOPS = {
    full: [
        { offset: '0%', stopColor: GOLD },
        { offset: '100%', stopColor: GOLD },
    ],
    half: [
        { offset: '51%', stopColor: GOLD },
        { offset: '51%', stopColor: WHITE, stopOpacity: 1 },
    ],
    empty: [
        { offset: '0%', stopColor: GOLD },
        { offset: '0%', stopColor: WHITE, stopOpacity: 1 },
    ],
}

function GradientStops({ variant }) {
    const stops = VARIANT_STOPS[variant] ?? VARIANT_STOPS.empty;
    return stops.map((s, i) => (
        <stop
            key={i}
            offset={s.offset}
            stopColor={s.stopColor}
            stopOpacity={s.stopOpacity}
        />
    ));
}

export function YotpoStar({ variant, idSuffix }) {
    const gradId = `yotpo_stars_gradient_${String(idSuffix).replace(/[^a-zA-Z0-9_-]/g, '_')}`;

    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
            className="star-container yotpo-sr-star"
            data-variant={variant}
            width="15"
            height="15"
        >
            <defs>
                <linearGradient id={gradId}>
                    <GradientStops variant={variant} />
                </linearGradient>
            </defs>
            <path
                style={{ pointerEvents: 'none' }}
                d={PATH_D}
                stroke={STROKE}
                fill={`url(#${gradId})`}
            />
        </svg>
    );
}

export function getYotpoStarVariants(reviewScore) {
    const scoreRaw = typeof reviewScore === 'number' && Number.isFinite(reviewScore)
        ? reviewScore
        : Number(reviewScore);
    const score = Number.isFinite(scoreRaw)
        ? Math.min(5, Math.max(0, scoreRaw))
        : 0;
    if (score >= 5) {
        return ['full', 'full', 'full', 'full', 'full'];
    }
    if (score <= 0) {
        return ['empty', 'empty', 'empty', 'empty', 'empty'];
    }
    if (score > 4 && score < 5) {
        return ['full', 'full', 'full', 'full', 'half'];
    }
    if (score == 4) {
        return ['full', 'full', 'full', 'full', 'empty'];
    }
    if (score > 3 && score < 4) {
        return ['full', 'full', 'full', 'half', 'empty'];
    }
    if (score == 3) {
        return ['full', 'full', 'full', 'empty', 'empty'];
    }
    if (score > 2 && score < 3) {
        return ['full', 'full', 'half', 'empty', 'empty'];
    }
    if (score == 2) {
        return ['full', 'full', 'empty', 'empty', 'empty'];
    }
    if (score > 1 && score < 2) {
        return ['full', 'half', 'empty', 'empty', 'empty'];
    }
    if (score == 1) {
        return ['full', 'empty', 'empty', 'empty', 'empty'];
    }
    if (score > 0 && score < 1) {
        return ['half', 'empty', 'empty', 'empty', 'empty'];
    }
    return ['empty', 'empty', 'empty', 'empty', 'empty'];
}
